// extracted by mini-css-extract-plugin
export var dividerLine = "_aj-3";
export var itemImage = "_aj-9";
export var lightDivider = "_aj-4";
export var modalContent = "_aj-5";
export var modalContentCompact = "_aj-6";
export var productCard = "_aj-a";
export var productImage = "_aj-b";
export var productImageCompact = "_aj-7";
export var productImagePlaceholder = "_aj-c";
export var productImagePlaceholderCompact = "_aj-8";
export var progressBarBackground = "_aj-1";
export var progressBarContainer = "_aj-0";
export var progressBarFill = "_aj-2";